import { render, staticRenderFns } from "./CreditCardValidationDataTable.vue?vue&type=template&id=0dd8c8a7&scoped=true"
import script from "./CreditCardValidationDataTable.vue?vue&type=script&lang=js"
export * from "./CreditCardValidationDataTable.vue?vue&type=script&lang=js"
import style0 from "./CreditCardValidationDataTable.vue?vue&type=style&index=0&id=0dd8c8a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8c8a7",
  null
  
)

export default component.exports